import moment from 'moment';
import qs from 'qs';
import React, { useState } from 'react';
import { withRouter } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { AutoSuggest } from 'components/Form/AutoSuggest';
import GetEvent from '../gql/queries/get-event';

const Container = styled.div`
  margin-left: 0;
  margin-top: 15px;
  margin-right: 10px;

  @media (min-width: 860px) {
    display: flex;
    flex-direction: column;
    width: 200px;
    margin-left: 20px;
    margin-top: 0;
  }
`;

const DateDropdown = (props) => {
  const { data, history } = props;
  const { date, ...query } = qs.parse(window.location.search.substring(1));

  const [eventDate, setDate] = useState(
    date !== undefined
      ? {
          value: date,
          label: moment(date, 'MM-DD-YYYY')
            .format('ddd MMM D - YYYY')
            .toUpperCase(),
        }
      : null
  );

  if (!data.getEvent) return false;

  return props.data.loading ? (
    <div />
  ) : (
    <Container>
      <AutoSuggest
        isSearchable={false}
        name="date"
        error={''}
        value={
          eventDate
            ? eventDate
            : {
                value: data.getEvent.eventDates[0],
                label: moment(data.getEvent.eventDates[0], 'YYYY-MM-DD')
                  .format('ddd MMM D - YYYY')
                  .toUpperCase(),
              }
        }
        closeMenuOnSelect
        options={data.getEvent.eventDates.map((item) => ({
          value: item,
          label: moment(item, 'YYYY-MM-DD')
            .format('ddd MMM D - YYYY')
            .toUpperCase(),
        }))}
        onChange={(date) => {
          setDate(date);
          const newQuery = qs.stringify({
            ...query,
            date: moment(date.value).format('MM-DD-YYYY'),
          });
          history.push(`?${newQuery} `);
        }}
      />
    </Container>
  );
};

export default withRouter(GetEvent(withTheme(DateDropdown)));
